import { color } from 'color-blend';
import { RGBA } from 'color-blend/dist/types';
import { PriceChangeDirection } from '../common/PricePrgClient';

const upBackgroundColor = "rgba(255, 0, 0, 0.2)";
const downBackgroundColor = "rgba(0, 255, 0, 0.2)";
const newArticleBackgroundColor = "rgba(255, 255, 0, 0.2)"

// Cache to prevent calculations of known blend results
const blendColorCache: {[colorMix: string]: string} = {};

export function getPriceChangeColors(priceChangeDirection?: PriceChangeDirection, defaultBgColor?: string, defaultColor?: string) {
    switch (priceChangeDirection) {
        case PriceChangeDirection.Up:
            return {
                color: blendColor('rgba(80, 0, 0, 0.87)', defaultColor),
                backgroundColor: blendColor(upBackgroundColor, defaultBgColor)
            };

        case PriceChangeDirection.Down:
            return {
                color: blendColor('rgba(0, 80, 0, 0.87)', defaultColor),
                backgroundColor: blendColor(downBackgroundColor, defaultBgColor)
            };

        case PriceChangeDirection.NewArticle:
            return {
                color: blendColor('rgba(80, 80, 0, 0.87)', defaultColor),
                backgroundColor: blendColor(newArticleBackgroundColor, defaultBgColor)
            };

        default:
            return {
                backgroundColor: defaultBgColor,
                color: blendColor('rgba(0, 0, 0, 0.87)', defaultColor)
            };
    }
}

export function getPriceChangeDirection(oldPrice?: number, newPrice?: number) {
    if (newPrice == null) {
        return PriceChangeDirection.Unaffected;
    }

    if (oldPrice == null) {
        return PriceChangeDirection.NewArticle;
    }

    if (newPrice > oldPrice) {
        return PriceChangeDirection.Up;
    }

    if (newPrice < oldPrice) {
        return PriceChangeDirection.Down;
    }

    return PriceChangeDirection.Unaffected;
}

function blendColor(primaryColor: string, secondaryColor?: string): string{
    if (secondaryColor == null || !primaryColor.startsWith("rgba") || !secondaryColor.startsWith("rgba")){
        return primaryColor;
    }

    const blendResult = blendColorCache[`${primaryColor}-${secondaryColor}`];
    if (blendResult != null){
        return blendResult;
    }

    const blendedColor = color(stringToRgba(secondaryColor), stringToRgba(primaryColor));
    const blendedColorStr = `rgba(${blendedColor.r}, ${blendedColor.g}, ${blendedColor.b}, ${blendedColor.a})`;
    blendColorCache[`${primaryColor}-${secondaryColor}`] = blendedColorStr;
    return blendedColorStr;
}

function stringToRgba(rgbaString: string): RGBA {
    const rgbaArr = rgbaString.replace(/[^\d,.]/g, '').split(',').map(Number);
    return {
        r: rgbaArr[0],
        g: rgbaArr[1],
        b: rgbaArr[2],
        a: rgbaArr[3]
    };
}